var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputValidator',{attrs:{"config":{
    attribute: _vm.getAttribute(),
    inputClass: _vm.getStyleClass(),
    label: _vm.control.label,
    name: _vm.control.label,
    maxlength: _vm.control.maxlength,
    placeholder: _vm.control.placeholder,
    readonly: _vm.control.readonly,
    required: !!_vm.control.required,
    type: _vm.type,
    value: _vm.value,
    validate: _vm.validators,
  },"tooltip":_vm.getTooltip()},on:{"InputValidatorModel":(value) => _vm.handleInputChange(value, _vm.$validator)}})
}
var staticRenderFns = []

export { render, staticRenderFns }